import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { ApiRequest } from '../../apiRequest'
import {
    getModelsWithRecommendationsApiUrl,
    getVwnRecommendationsApiUrl,
    getVwnRecommendationsTrackingApiUrl,
} from '../../../constants/apiUrls'
import {
    fetchVwnRecommendationsForModel,
    fetchVwnRecommendationsForModelAsync,
    fetchVwnModelsWithRecommendations,
    fetchVwnModelsWithRecommendationsAsync,
    setVwnModelsWithRecommendationsData,
    setVwnRecommendationsForModelData,
    trackVwnRecommendedEquipments,
    trackVwnRecommendedEquipmentsAsync,
} from '../../actions/app/vwnRecommendation.actions'

const vwnRecommendationsMiddleware =
    (apiRequest: ApiRequest): Middleware => (store) => (next) => (action) => {
        next(action)
        const {dispatch} = store

        if (isActionOf(fetchVwnModelsWithRecommendations, action)) {
            apiRequest({
                options: {
                    url: getModelsWithRecommendationsApiUrl(),
                    method: 'GET',
                },
                asyncActions: fetchVwnModelsWithRecommendationsAsync,
                causedBy: action,
            }, dispatch)
        }

        if (isActionOf(fetchVwnRecommendationsForModel, action)) {
            apiRequest({
                options: {
                    url: getVwnRecommendationsApiUrl(),
                    method: 'GET',
                },
                asyncActions: fetchVwnRecommendationsForModelAsync,
                causedBy: action,
            }, dispatch)
        }

        if (isActionOf(trackVwnRecommendedEquipments, action)) {
            const recommendationTrackingData = action.payload

            apiRequest({
                options: {
                    url: getVwnRecommendationsTrackingApiUrl(),
                    method: 'POST',
                    body: JSON.stringify(recommendationTrackingData),
                },
                asyncActions: trackVwnRecommendedEquipmentsAsync,
                causedBy: action,
            }, dispatch)
        }

        if (isActionOf(fetchVwnModelsWithRecommendationsAsync.success, action)) {
            const modelsWithRecommendationsData = action.payload

            dispatch(setVwnModelsWithRecommendationsData(modelsWithRecommendationsData))
        }

        if (isActionOf(fetchVwnRecommendationsForModelAsync.success, action)) {
            const recommendationsForModelData = action.payload

            dispatch(setVwnRecommendationsForModelData(recommendationsForModelData))
        }
    }

export default vwnRecommendationsMiddleware
